exports.base_url = "https://afya.afyachat.net/r/";
exports.org = "afya";
exports.env = "sandbox";
